import React from 'react';
import { Helmet } from 'react-helmet-async';

const Innovation = () => {
  return (
    <div className="container">
      <Helmet>
        <title>Ariel Rotem | AI Researcher & Inventor</title>
        <meta name="description" content="Ariel Rotem leads AI research initiatives including IPTorch, ResearchAutominer, and MedCiter, alongside holding active patents." />
      </Helmet>
      <div className="mb-4">
        <h1 className="glitch" style={{ color: 'var(--accent-secondary)', fontSize: '2.5rem' }}>$ ./ai_research_innovator.sh</h1>
        <p className="mono" style={{ color: 'var(--text-secondary)' }}>
          Loading AI modules... [OK]<br/>
          Parsing patent database... [OK]<br/>
          Initializing Pro Bono protocols... [OK]
        </p>
      </div>

      <div className="terminal-card">
        <h3 className="mb-2" style={{ color: 'var(--accent-secondary)', borderBottom: '1px dashed var(--text-secondary)', paddingBottom: '10px' }}>
          &gt; RESEARCH_ORIGINS.log
        </h3>
        <p className="mono text-secondary" style={{ fontSize: '0.9rem' }}>
          My journey into research began during my BSc. Mathematics & Computer Science, where I first <a href="https://www.ariel.ac.il/wp/acic/research/identifying-encrypted-traffic/" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'underline'}}>dabbed in the waters</a> of scientific inquiry (identifying encrypted traffic). This early exposure, even if just a <a href="https://omrier.wixsite.com/eran-omri/secureandprivatedistributed#:~:text=Ariel%20Rotem" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'underline'}}>short acquaintance</a>, ignited an appetite for complex analysis that only grew during my tenure at IBM exploring cutting-edge fraud detection models.
        </p>
        <p className="mono mt-1">
          Today, leveraging extensive experience in massive data analytics and software engineering, my focus has shifted heavily toward Artificial Intelligence. I build AI tools—often pro bono—to assist researchers in traversing complex datasets and orchestrating insights that facilitate critical advancements in medicine and technology.
        </p>
      </div>

      <div className="terminal-card mt-4">
        <h3 className="mb-2" style={{ color: 'var(--accent-tertiary)', borderBottom: '1px dashed var(--text-secondary)', paddingBottom: '10px' }}>
          &gt; PUBLICATIONS.log
        </h3>
        <p className="mono text-secondary" style={{ fontSize: '0.9rem' }}>
          [ Processing new manuscripts... Check Google Scholar for synchronized updates. ]
        </p>
      </div>

      <div className="grid grid-cols-2 mt-4">
        <div className="terminal-card">
          <h3 className="mb-2" style={{ color: 'var(--accent-primary)' }}>&gt; AI_VENTURES && PRO_BONO</h3>
          
          <div className="mt-2 text-primary">
            <h4 className="mono" style={{ color: 'var(--accent-primary)' }}>[ IPTorch ] :: AI-Powered Patent Search</h4>
            <p className="mono mt-1 text-secondary" style={{ fontSize: '0.85rem' }}>
              Helped POC an AI-backed framework for advanced patent search. A real-world intro to productizing AI models. (visit: <a href="https://www.iptorch.com" target="_blank" rel="noopener noreferrer">iptorch.com</a>)
            </p>
          </div>

          <div className="mt-4 text-primary">
            <h4 className="mono" style={{ color: 'var(--accent-primary)' }}>[ ResearchAutominer ] :: V1 & V2 (Open Source)</h4>
            <p className="mono mt-1 text-secondary" style={{ fontSize: '0.85rem' }}>
              Pro bono initiative enabling clinical researchers to analyze large-scale patient datasets. Deployed in real-world OB-GYN research at Sheba Medical Center.
            </p>
          </div>

          <div className="mt-4 text-primary">
            <h4 className="mono" style={{ color: 'var(--accent-primary)' }}>[ MedCiter ] :: AI Citation Discovery</h4>
            <p className="mono mt-1 text-secondary" style={{ fontSize: '0.85rem' }}>
              Free tool built on a custom vectorized search engine helping researchers dynamically find relevant citations and build foundational structures for their work.
            </p>
          </div>
        </div>

        <div>
          <div className="terminal-card" style={{ height: 'auto', marginBottom: '24px' }}>
            <h3 className="mb-2" style={{ color: 'var(--accent-tertiary)' }}>&gt; PATENTS.DAT</h3>
            <ul className="mono text-secondary" style={{ paddingLeft: '20px', fontSize: '0.85rem' }}>
              <li className="mb-2">
                <span className="text-primary">Electrical Suction Lifting Machine</span><br/>
                U.S. Design Patent No. D1067573<br/>
                Granted: Mar 18, 2025 | Inventor: Ariel Rotem<br/>
                <a href="https://patents.justia.com/inventor/ariel-rotem" target="_blank" rel="noopener noreferrer">View Record</a>
              </li>
              <li className="mb-2">
                <span className="text-primary">Suction Cup for Attachment</span><br/>
                U.S. Design Patent No. D1070219<br/>
                Granted: Apr 8, 2025 | Inventor: Ariel Rotem<br/>
                <a href="https://patents.justia.com/inventor/ariel-rotem" target="_blank" rel="noopener noreferrer">View Record</a>
              </li>
              <li className="mb-2">
                <span className="text-primary">Vacuum Gripper</span><br/>
                U.S. Patent Application 30/024,606<br/>
                Filed: 2026 | Inventors: N. Rotem, O. Joukov, E. Rotem, A. Rotem<br/>
              </li>
              <li className="mb-1">
                <span className="text-primary">Lifting Apparatus</span><br/>
                Patent Application<br/>
                Inventors: N. Rotem, O. Joukov, E. Rotem, A. Rotem<br/>
              </li>
            </ul>
          </div>

          <div className="terminal-card" style={{ height: 'auto' }}>
            <h3 className="mb-2" style={{ color: 'var(--accent-secondary)' }}>&gt; OUTPUT_LINKS</h3>
            <p className="mono text-secondary" style={{ fontSize: '0.85rem' }}>
              - <a href="https://scholar.google.com/citations?user=14b33J0AAAAJ" target="_blank" rel="noopener noreferrer">Google Scholar</a> (Publications & Papers under dev)<br/>
              - <a href="https://github.com/ArielRotem" target="_blank" rel="noopener noreferrer">GitHub / Open Source Code</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Innovation;
